<template>
  <div id="processesWrapper">
    <div class="notification" v-if="running.indexes.length === 0">Geen lopende processen gevonden</div>

    <table
      v-else
      class="table is-striped is-hoverable">

      <thead>
        <tr>
          <th>Gebruiker</th>
          <th>Bundel</th>
          <th>Tabel</th>
          <th>Actie</th>
          <th>Voortgang</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for="(key, idx) in running.indexes"
          :key="idx"
          :class="{ 'has-background-danger': orphans.includes(key) }">

          <td>{{ getUserName(key) }}</td>
          <td>{{ getBundleName(key) }}</td>
          <td>{{ getTableName(key) }}</td>
          <td>{{ getProcessName(key) }}</td>
          <td>{{ getProgress(key) }}</td>
          <td>{{ getStatus(key) }}</td>
          <td>
            <options-buttons
              :editing="false"
              @delete="remove(key)">
            </options-buttons>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OptionsButtons from '@/components/modules/OptionsButtons'

export default {
  name: 'Processes',
  components: {
    OptionsButtons
  },
  computed: {
    ...mapGetters({
      users: 'users/users',
      tables: 'tables/tables',
      bundles: 'bundles/bundles',
      running: 'processes/running'
    }),
    keys () {
      return this.running.processes.map(process => {
        return process.key
      })
    },
    orphans () {
      return this.running.indexes.filter(key => !this.keys.find(x => x === key))
    }
  },
  created () {
    this.$store.dispatch('processes/loadAll')
  },
  methods: {
    getUserName (key) {
      const userId = /^u:([0-9]+):/.exec(key)
      const user = this.users.find(x => x.id === parseInt(userId[1]))

      if (user) {
        return `${user.firstname} ${user.lastname}`
      }

      return 'Gebruiker niet gevonden'
    },
    getTableName (key) {
      const tableId = /t:([0-9]+)$/.exec(key)
      const table = this.tables.find(x => x.id === parseInt(tableId[1]))

      if (table) {
        return table.name
      }

      return 'Tabel niet gevonden'
    },
    getBundleName (key) {
      const bundleId = /b:([0-9]+):/.exec(key)
      const bundle = this.bundles.find(x => x.id === parseInt(bundleId[1]))

      if (bundle) {
        return bundle.name
      }

      return 'Bundel niet gevonden'
    },
    getProcessName (key) {
      if (this.orphans.includes(key)) return '-'

      const process = this.running.processes.find(x => x.key === key)

      const types = [
        'Regels genereren',
        'Regels importeren',
        'Regels verwijderen',
        'Regels wijzigen',
        'Bundel kopiëren'
      ]

      return types[process.value.type]
    },
    getProgress (key) {
      if (this.orphans.includes(key)) return '-'

      const process = this.running.processes.find(x => x.key === key)

      return `${process.value.done}/${process.value.total}`
    },
    getStatus (key) {
      if (this.orphans.includes(key)) return 'Bestaat niet meer'

      const process = this.running.processes.find(x => x.key === key)

      if (parseInt(process.value.done) === 0) return 'Nog niet gestard of vastgelopen'
      if (parseInt(process.value.done) < parseInt(process.value.total)) return 'Wordt verwerkt'
      if (parseInt(process.value.done) >= parseInt(process.value.total)) return 'Afgehandeld'

      return 'Onbekend'
    },
    remove (key) {
      this.$store.dispatch('processes/kill', key)
    }
  }
}
</script>

<style lang="css">
</style>
